import { useRouter } from 'next/navigation'
import { getPropertyDetailsImageUrl } from '@/utils/imageUtils'

interface Props {
    data: PropertyData
}

interface PropertyData {
  main_photo?: string
  other_photos?: PropertyPhoto[]
  [key: string]: unknown
}
interface PropertyPhoto {
  original_img_url?: string
  large_img_url?: string
  medium_img_url?: string
  [key: string]: unknown
}


export const useMobilePropertyImg = ({ data }: Props) => {
  

  const router = useRouter()

  // Skip main photo for now, only use other photos - prioritize higher quality

  const allImages: string[] = [
    // data?.main_photo,
    ...(data?.other_photos?.map((img: PropertyPhoto) => getPropertyDetailsImageUrl(img)).filter((url): url is string => Boolean(url)) ||
      []),
  ]

  // If no other photos, use main photo as fallback
  const hasOtherPhotos = (data?.other_photos ?? []).length > 0
  const displayImages = hasOtherPhotos
    ? allImages
    : [data?.main_photo].filter(Boolean)

  // Determine the image to preload & prioritize - use optimized quality
  const mainImage = hasOtherPhotos
    ? getPropertyDetailsImageUrl(data?.other_photos?.[0])
    : data?.main_photo

  return {
    mainImage,
    displayImages,
    hasOtherPhotos,
    router,
  }
}
